<template>
  <Head :title="__('faq.meta.title')">
    <meta
      name="description"
      :content="__('faq.meta.description')"
    >
    <link
      rel="canonical"
      :href="localeRoute('frontend.faq')"
    >
    <meta
      property="og:image"
      content="/frontend/assets/favicon/og-image.jpg"
    >
  </Head>

  <section class="faq-hero py-8 md:py-20 relative overflow-hidden">
    <img
      src="/frontend/assets/mobile-hero-swirl.svg"
      class="absolute top-0 left-0 lg:hidden"
    >
    <img
      src="/frontend/assets/desktop-hero-swirl.svg"
      class="absolute top-0 left-0 hidden lg:block"
    >

    <div class="container">
      <div class="text-center px-8">
        <h1 class="text-5xl font-bold lg:text-7xl">
          {{ __('faq.title') }}
        </h1>
      </div>
    </div>
  </section>

  <section class="faq text-lg py-8 md:py-20 relative bg-white">
    <img
      src="/frontend/assets/scribble-round-desktop.svg"
      class="hidden lg:block absolute left-0 top-[400px]"
    >

    <div class="container">
      <div class="faq-item mb-12 lg:px-8">
        <h2 class="text-4xl font-bold">
          {{ __('faq.rules.title') }}
        </h2>
        <p>
          {{ __('faq.rules.allowed.title') }}
        </p>
        <ul class="list-inside mb-4 mb-4 list-disc">
          <li
            v-for="(value, index) in $tm('faq.rules.allowed.list')"
            :key="index"
          >
            {{ value }}
          </li>
        </ul>

        <p>
          {{ __('faq.rules.not-allowed.title') }}
        </p>
        <ul class="list-inside mb-4 list-disc">
          <li
            v-for="(value, index) in $tm('faq.rules.not-allowed.list')"
            :key="index"
          >
            {{ value }}
          </li>
        </ul>
        <p>
          {{ __('faq.rules.agreed.title') }}
        </p>
        <ul class="list-inside mb-4 list-disc">
          <li
            v-for="(value, index) in $tm('faq.rules.agreed.list')"
            :key="index"
          >
            {{ value }}
          </li>
        </ul>

        <p>
          <i18n-t
            keypath="faq.rules.text"
            scope="global"
          >
            <template #link>
              <Link
                :href="localeRoute('frontend.terms-and-conditions')"
                class="text-blue-600 underline hover:no-underline"
              >
                {{ __('faq.rules.text-link-text') }}
              </Link>
            </template>
          </i18n-t>
        </p>
      </div>

      <div class="faq-item mb-12 lg:px-8">
        <h2 class="text-4xl font-bold">
          {{ __('faq.give-away.title') }}
        </h2>
        <ul class="list-inside mb-4 list-disc">
          <li
            v-for="(value, index) in $tm('faq.give-away.text')"
            :key="index"
          >
            {{ value }}
          </li>
        </ul>
      </div>

      <div class="faq-item mb-12 lg:px-8">
        <h2 class="text-4xl font-bold">
          {{ __('faq.questions.title') }}
        </h2>

        <div class="grid grid-cols-1 gap-6 mt-8 ">
          <FaqItem
            v-for="(value, index) in $tm('faq.questions.questions')"
            :key="index"
            :index="index + 1"
            :default-open="index === 0"
            :question="value.title"
            :answer="value.text"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FaqItem from '../../Components/FaqItem.vue';

export default {
  components: {
    FaqItem,
  },
};
</script>
